import { Component, OnInit } from '@angular/core';

import { PersonModel } from '@bayclubs/court-booking-employee-api';

import { PlayersFacade } from '../../+store/players.facade';

@Component({
    selector: 'app-player-list',
    templateUrl: './player-list.component.html',
    styleUrls: ['./player-list.component.scss'],
    standalone: false
})
export class PlayerListComponent implements OnInit {
    players$ = this.playerFacade.players$;
    selectedPlayer$ = this.playerFacade.selectedPlayer$;
    constructor(private playerFacade: PlayersFacade) { }

    ngOnInit(): void { }

    onPlayerSelected(player: PersonModel) {
        this.playerFacade.selectPlayer(player);
    }
}
